import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Metabase from './components/Metabase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardRoster',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Metabase)
  ]))
}
}

})